import styled from 'styled-components';

export const Page = styled.main`
  margin: 50px;
  @media screen and (max-width: 600px) {
    margin: 10px;
    margin-bottom: 80px;
  }
  margin-bottom: 80px;
`;
